import React from "react";

import { IgPaper } from "@intelligems/ig-theme";
import { Box, Grid, Paper } from "@mui/material";

export const ShareRoute = () => {
  return (
    <Grid
      container
      sx={{ width: "100vw", height: "100vh" }}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Grid item>
        <IgPaper>
          <Box
            component={"img"}
            src={
              "https://dev-cdn.intelligems.io.s3.amazonaws.com/dbdca76f-03b5-41dc-9e93-16964cdc0ea4.png"
            }
          />
        </IgPaper>
      </Grid>
    </Grid>
  );
};
